<script>
  import VueBase64FileUpload from 'vue-base64-file-upload'
  import swal from 'sweetalert2'

  export default {
    name: 'form-single-upload',
    components: {VueBase64FileUpload},
    props: {
      model: {
        default: function () {
          return {}
        },
        type: Object
      },
      maxFileSize: {default: 5, type: Number},
      acceptedTypes: {default: '*'},
      placeholder: {default: 'Clique aqui para selecionar um arquivo'},
      isInvalid: {default: false, type: Boolean}
    },
    data () {
      return {
        isAvailable: true,
        isInvalidType: false,
        file: {
          name: '',
          size: '',
          base64: '',
          type: ''
        }
      }
    },
    created: function () {
      this.file.name = this.model.name
      if (this.file.name && this.file.name.length > 0) {
        this.isAvailable = false
      } else {
        this.$emit('update:isInvalid', true)
      }
    },
    methods: {
      onFile (file) {
        if (this.acceptedTypes === '*' || file.type.match(this.acceptedTypes)) {
          this.file.type = file.type
          this.file.name = file.name
          this.file.size = file.size
          this.isInvalidType = false
          this.$emit('update:model', this.file)
          this.$emit('update:isInvalid', false)
        } else {
          this.isInvalidType = true
          this.$emit('update:isInvalid', true)
          swal({
            title: 'Atenção - Formato inválido',
            text: 'O formato do arquivo selecionado é inválido, só são os formatos:' + this.acceptedTypes + '.',
            type: 'warning'
          })
        }
      },
      onLoad (dataUri) {
        if (!this.isInvalidType) {
          this.file.base64 = dataUri
          this.isAvailable = false
          this.$emit('update:model', this.file)
          this.$emit('update:isInvalid', false)
        }
      },
      onSizeExceeded () {
        swal({
          title: 'Atenção - Tamanho excedido',
          text: 'O tamanho máximo do arquivo é de ' + this.maxFileSize + ' mb.',
          type: 'warning'
        })
      },
      onDelete () {
        this.file = {
          name: '',
          size: '',
          base64: '',
          type: ''
        }
        this.$emit('update:model', {})
        this.$emit('update:isInvalid', true)
        this.reset()
      },
      reset () {
        this.isAvailable = false
        const _this = this
        setTimeout(() => {
          _this.isAvailable = true
        })
      }
    }
  }
</script>

<template>
    <div>
        <div class="single-file-upload-box">
            <span v-if="!isAvailable">{{file.name}}</span>
            <el-button type="danger"
                       v-if="!isAvailable"
                       class="file-exists"
                       @click="onDelete(file)">
                <i class="fa fa-times"></i>
            </el-button>
            <vue-base64-file-upload
                    input-class="uploader"
                    :accept="acceptedTypes"
                    v-if="isAvailable"
                    :disable-preview="true"
                    placeholder="Clique aqui para selecionar um arquivo"
                    :max-size="maxFileSize"
                    @size-exceeded="onSizeExceeded"
                    @file="onFile"
                    @load="onLoad"/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// SingleUpload.vue?1c1ce570